// @core/api/endpoints/chat/get_chat_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ChatPolicyResponse,
} from '../../../types/chat';

const BASE_PATH = '/chat';

/**
 * Get chat policy
 * Returns a chat policy by ID.
 */
export async function GetChatPolicy(
  policy_id: string,
  options?: RequestOptions
): Promise<ChatPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/chat-policies/:policy_id`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.get<ChatPolicyResponse>(requestPath, { ...requestOptions });
}
